module.exports = __webpack_public_path__ + "video.68c08572.png";